module.exports = __webpack_public_path__ + "static/media/pstep2img3.2337b42d.PNG";